import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  path?: string;
  image?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "Banana Cup - Climbing App | Climbing Logger with Heart Rate Monitor | BananaCup.be",
  description = "Track your climbing progress with Banana Cup climbing app. The ultimate climbing logger with heart rate monitor integration for serious climbers and enthusiasts. In support of the paraclimbing community.",
  keywords = "klimapp, klim app, climbing app, bananacup.be, banana cup, paraclimbing, paraklimmen, log climbs, climbing logger, climbing logger with heart rate monitor, paraklimmen.be, climbing tracker, climbing progress, climbing gym, route tracker, climbing community",
  path = "",
  image = "/logo512.png",
  type = "website"
}) => {
  const siteUrl = "https://bananacup.be";
  const fullUrl = `${siteUrl}${path}`;
  const fullImageUrl = `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="Banana Cup" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
};

export default SEO;
